import {Action} from "@ngrx/store";
import {Roles} from "../models/roles.model";

export const ADD_ROLE = "[ROLE] add";
export const REMOVE_ROLE = "[ROLE] remove";
export const CLEAR_ROLE = "[ROLE] clear";

export class AddRole implements Action {
    readonly type = ADD_ROLE;
    constructor(public payload: Roles){
    }
}

export class RemoveRole implements Action {
    readonly type = REMOVE_ROLE;
    constructor(public payload: number){
    }
}

export class ClearRole implements Action {
    readonly type = CLEAR_ROLE;
    constructor(){
    }
}

export type RolesActions = AddRole | RemoveRole | ClearRole;